import decode from 'jwt-decode';

const ACCESS_TOKEN_KEY = 'access_token';

export function getAccessToken() {
  return sessionStorage.getItem(ACCESS_TOKEN_KEY);
}

export function clearAccessToken() {
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function getParameterByName(name) {
  const match = RegExp(`[#&]${name}=([^&]*)`).exec(window.location.hash);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export function setAccessToken(accessToken) {
  sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

export function getTokenExpirationDate(encodedToken) {
  const token = decode(encodedToken);

  if (!token.exp) { return null; }

  const date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

export function isTokenExpired(token) {
  const expirationDate = this.getTokenExpirationDate(token);
  return expirationDate < new Date();
}
